import React, { useState, useEffect, useLayoutEffect } from "react"
import { useTranslation } from "react-i18next"

import { TextField } from "components"
import TdFormShapes from "./TdFormShapes"
import TdFormCapacity from "./TdFormCapacity"
import TdFormShapeSizes from "./TdFormShapeSizes"
import TdSaveButton from "./TdSaveButton"
import TdFormLevel from "./TdFormLevel"
import classes from "./index.module.scss"

const initialFormState = {
  tableNumber: "",
  level: "",
  capacity: "1",
  shape: "square",
  scale: "small"
}

const TdForm = props => {
  const {
    selectedTable,
    setSelectedTable,
    setLayout,
    tables,
    setTables,
    setSelectedFloor
  } = props

  const [t] = useTranslation()

  const [form, setForm] = useState(initialFormState)

  const handleChange = (value, name) => {
    setForm(prev => ({
      ...prev, [name]: value
    }))
  }

  const fillForm = () => {
    if (selectedTable === null) return

    const {
      tableNumber,
      capacity,
      level = "",
      shape,
      scale
    } = selectedTable

    setForm({
      tableNumber,
      level,
      capacity: String(capacity),
      shape,
      scale
    })
  }

  useLayoutEffect(() => {
    fillForm()
  }, [selectedTable])

  useEffect(() => {
    return () => setSelectedTable(null)
  }, [])

  return (
    <div className={classes["container"]}>
      <div className={classes["item"]}>
        <div className={classes["title"]}>
          {t("شماره_میز")}
        </div>
        <TextField
          inputClassName={classes["input"]}
          value={form.tableNumber}
          onChange={(e) => handleChange(e.target.value, "tableNumber")}
        />
      </div>
      <TdFormLevel
        form={form}
        tables={tables}
        setForm={setForm}
      />
      <TdFormCapacity
        form={form}
        setForm={setForm}
      />
      <TdFormShapes
        form={form}
        setForm={setForm}
      />
      <TdFormShapeSizes
        form={form}
        setForm={setForm}
      />
      <TdSaveButton
        form={form}
        tables={tables}
        setTables={setTables}
        selectedTable={selectedTable}
        setLayout={setLayout}
        setSelectedFloor={setSelectedFloor}
      />
    </div>
  )
}

export default TdForm